<template>
  <div
    class="switcher flex items-center gap-2 justify-between w-fit"
  >
    <div
      class="switcher__track"
      :class="{
        'switcher__track--checked': modelValue,
        [`switcher__track--${size}`]: size,
        'switcher__track--disabled': disabled
      }"
      :style="{
        order: switcherOrder
      }"
      @click="toggleSwitcher"
    >
      <div
        class="switcher__circle"
        :class="{
          'switcher__circle--checked': modelValue,
          [`switcher__circle--${size}`]: size
        }"
      />
    </div>

    <div v-if="$slots.label"
         class="switcher__label">
      <slot name="label" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InputSwitcher',
    props: {
      switcherOrder: {
        type: Number,
        default: 0,
      },
      size: {
        type: String,
        required: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      modelValue: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      toggleSwitcher() {
        if (this.disabled) {
          return;
        }
        this.$emit('update:modelValue', !this.modelValue);
      },
    },
  };
</script>

<style lang="scss" scoped>
.switcher {
  &__track {
    flex-shrink: 0;
    width: 44px;
    height: 24px;
    background: var(--gray200);
    border-radius: 90px;
    padding: 4px;
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    transition: background-color 300ms ease-in-out;
    &--large {
      width: 52px;
      height: 32px;
    }
    &--checked {
      background-color: var(--color-base-500);
    }
    &--disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
  &__circle {
    position: relative;
    left: 0;
    width: 16px;
    height: 16px;
    background-color: var(--gray400);
    border-radius: 50%;
    transition:
      left 300ms ease-in-out,
      background-color 300ms ease-in-out;
    --left-space: 16px;
    &--large {
      width: 24px;
      height: 24px;
      --left-space: 24px;
    }
    &--checked {
      background-color: var(--shadesWhite);

      &:dir(ltr) {
        left: calc(100% - var(--left-space));
      }

      &:dir(rtl) {
        right: calc(100% - var(--left-space));
      }
    }
  }
}
</style>
